import React from "react";
const MapTable = ({
  data,
  regulationType,
  handleLoadMore,
  pageSize,
  dataCount,
}) => {
  const capitalizeFirstLetter = (text) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };
  return (
    <div>
      {data?.length ? (
        <>
          {data?.map((item, index) => (
            <React.Fragment key={index}>
              <div className="lmap-content-container">
                <p className="state-name-map">
                  {item?.reference_title
                    ? item?.reference_title
                    : regulationType === "Legislation"
                      ? `${item?.session_id}${item?.state}${item?.number}`
                      : regulationType === "Agency Docs"
                        ? `${item?.state}${item?.number}`
                        : `${item?.calendar_year}${item?.state}${item?.number}`}
                </p>
                <div className="sub-details-of-state-name">
                  <div className="author-name-map">
                    <div className="both-news-time-comp">
                      <p className="news-comp-map">
                        <a
                          href={item?.public_text_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link to full {item?.track_type}
                        </a>
                      </p>
                    </div>
                  </div>
                  <p>|</p>
                  <div className="author-name-map">
                    <p className="personal-detail-map">Type: </p>
                    <p className="identity-detail-map">{item?.track_type}</p>
                  </div>
                  <p>|</p>
                  <div className="author-name-map">
                    <p className="personal-detail-map">Status: </p>
                    <p className="identity-detail-map">
                      {item?.current_disposition ||
                        item?.passage_status ||
                        item?.status ||
                        "n/a"}
                    </p>
                  </div>
                  <p>|</p>
                  <div className="author-name-map">
                    <p className="personal-detail-map">State: </p>
                    <p className="identity-detail-map">{item?.state_name}</p>
                  </div>
                  <p>|</p>
                  <div className="author-name-map">
                    <p className="personal-detail-map">Date: </p>
                    <p className="identity-detail-map">
                      {item?.last_update_date}
                    </p>
                  </div>
                </div>
                <p className="sub-head-details-map">
                  {capitalizeFirstLetter(item?.title)}
                </p>
                <p className="inner-artical-map">
                  {capitalizeFirstLetter(item?.summary)}
                </p>
              </div>
            </React.Fragment>
          ))}
        </>
      ) : (
        <p className="text-center-result">
          Please select or update filters to view results
        </p>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data?.length < dataCount && (
          <button
            className="button-loadmore-pagination"
            onClick={handleLoadMore}
          >
            Load More
          </button>
        )}
      </div>
    </div>
  );
};
export default MapTable;
